<template>
  <div class="">
    <a-space>
      <search-vue @emitSearch="handleSearch" />
      <a-button type="primary" @click="startiqcModal"
        >添加仓库来料记录</a-button
      >
    </a-space>
    <!-- <div style="width: 1800px; margin-top: 20px"> -->
    <a-table
      :dataSource="tableData"
      :columns="columns"
      :pagination="false"
      :loading="tableLoading"
      :scroll="{ x: 1800 }"
      rowKey="id"
      bordered
    >
      <template #action="{ record }">
        <a-button size="small" @click="handleEdit(record)">编辑</a-button>
      </template>

      <template #iqcIndex="{ index }">
        {{ index + 1 }}
      </template>

      <template #status="{ record }">
        <a-tag v-if="record.type === -1" color="#87d068">已完成</a-tag>
        <a-tag v-if="record.type === 2" color="pink">仓管</a-tag>
        <a-tag v-if="record.type === 3" color="red">质检</a-tag>
      </template>

      <template #concessionIssues="{ record }">
        <div v-for="(item, index) in record.concessionDesc" :key="index">
          <div>{{ item.desc }}</div>
          <div v-for="(img, index) in JSON.parse(item.picture)" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in JSON.parse(item.video)" :key="index">
            <video :src="video" controls width="80" :key="video"></video>
          </div>
        </div>
      </template>

      <template #intransigenceDesc="{ record }">
        <div v-for="(item, index) in record.intransigenceDesc" :key="index">
          <div>{{ item.desc }}</div>
          <div v-for="(img, index) in JSON.parse(item.picture)" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in JSON.parse(item.video)" :key="index">
            <video :src="video" controls width="80" :key="video"></video>
          </div>
        </div>
      </template>
    </a-table>
    <!-- </div> -->
  </div>
  <iqcmodal-vue ref="iqcmodalRef" @updateTable="getIQCdata" />
  <roll-back-modal ref="rollBackModal" @rollBack="rollBack"></roll-back-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import {
  getIQCList,
  IQCInspectionRollback,
  IQCInspectionConfirm,
} from "@/request/view/qualityInspection";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, debounce } from "@/utils/index";
import searchVue from "./components/search.vue";
import iqcmodalVue from "./components/iqcmodal.vue";
import rollBackModal from "@/views/repairprogress/compoments/rollBackModal.vue";

export default defineComponent({
  components: { searchVue, iqcmodalVue, rollBackModal },
  setup() {
    const columns = [
      {
        title: "序号",
        width: 80,
        align: "center",
        slots: { customRender: "iqcIndex" },
      },
      {
        title: "名称",
        dataIndex: "name",
        align: "center",
        width: 140,
      },
      {
        title: "编码",
        dataIndex: "code",
        align: "center",
        width: 140,
      },
      {
        title: "物料批号",
        dataIndex: "materialBatch",
        align: "center",
        width: 140,
      },
      {
        title: "SN号",
        dataIndex: "snNumber",
        align: "center",
        width: 140,
      },
      {
        title: "供应商名称",
        dataIndex: "supplier",
        align: "center",
        width: 140,
      },
      {
        title: "物料类型",
        dataIndex: "materialType",
        align: "center",
        width: 100,
      },
      {
        title: "来料属性",
        dataIndex: "incomingMaterialProperties",
        align: "center",
        width: 100,
      },
      {
        title: "来料数量",
        dataIndex: "incomingMaterialNumber",
        align: "center",
        width: 100,
      },
      {
        title: "送检人",
        dataIndex: "inspectionPersonnel",
        width: 90,
        align: "center",
      },
      {
        title: "状态",
        slots: { customRender: "status" },
        width: 100,
      },
      {
        title: "合格率",
        dataIndex: "passRate",
        width: 90,
        align: "center",
      },
      {
        title: "送检数量",
        dataIndex: "submissionNumber",
        align: "center",
        width: 100,
      },
      {
        title: "抽检/全检",
        dataIndex: "inspectionMethod",
        align: "center",
        width: 100,
      },

      {
        title: "检验数量",
        dataIndex: "inspectionNumber",
        align: "center",
        width: 100,
      },
      {
        title: "合格数量",
        dataIndex: "qualifiedNumber",
        align: "center",
        width: 100,
      },
      {
        title: "不合格数量",
        children: [
          {
            title: "让步数量",
            dataIndex: "concessionNumber",
            align: "center",
            width: 100,
          },
          {
            title: "不能让步数量",
            dataIndex: "intransigenceNumber",
            align: "center",
            width: 130,
          },
        ],
      },
      {
        title: "检验人",
        dataIndex: "inspector",
        width: 90,
        align: "center",
      },
      {
        title: "类型",
        dataIndex: "model",
        align: "center",
        width: 100,
      },
      {
        title: "让步接收问题描述",
        dataIndex: "concessionIssues",
        slots: { customRender: "concessionIssues" },
        align: "center",
        width: 180,
      },
      {
        title: "不能让步问题描述",
        dataIndex: "intransigenceDesc",
        slots: { customRender: "intransigenceDesc" },
        align: "center",
        width: 180,
      },
      {
        title: "操作",
        slots: { customRender: "action" },
        width: 90,
        fixed: "right",
      },
    ];

    let query = {};

    const tableData = reactive([]);
    const tableLoading = ref(false);
    const iqcmodalRef = ref();

    const startiqcModal = () => {
      iqcmodalRef.value.openModal("addIQC");
    };

    const getIQCdata = () => {
      tableData.length = 0;
      tableLoading.value = true;
      getIQCList(query)
        .then((res) => {
          tableLoading.value = false;
          if (res.code === 200 && res.message === "成功" && res.data) {
            Object.keys(res.data).forEach((key) => {
              res.data[key].forEach((item) => {
                item.concessionDesc = JSON.parse(item.concessionDesc);
                item.intransigenceDesc = JSON.parse(item.intransigenceDesc);
                item.notes = JSON.parse(item.notes);
              });

              tableData.push(...res.data[key]);
            });
          }
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err);
        });
    };

    const handleEdit = (e) => {
      iqcmodalRef.value.openModal("editIQC", e);
    };

    const handleInspectionConfirm = (record) => {
      showModal({
        title: "提示",
        toastText: "确认质检完成？",
        success: () => {
          IQCInspectionConfirm({
            IQCId: record.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getIQCdata();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const rollBackModal = ref();

    let rollBackId = null;
    const handleInspectionRollBack = (e) => {
      rollBackId = e.id;
      rollBackModal.value.showModal();
      rollBackModal.value.setInputData(e.rollbackReason);
    };
    const rollBack = (e) => {
      IQCInspectionRollback({
        IQCId: rollBackId,
        rollbackReason: e,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (res.code === 200) {
            rollBackModal.value.handleCancel();
            getIQCdata();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const handleSearch = debounce((e) => {
      query = e;
      getIQCdata();
    }, 300);

    return {
      columns,
      tableData,
      iqcmodalRef,
      tableLoading,
      getIQCdata,
      startiqcModal,
      handleEdit,
      handleSearch,
      rollBack,
      rollBackModal,
      handleInspectionConfirm,
      handleInspectionRollBack,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
